import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.NetSuiteRequestCard.NetSuiteItemReceiptExpenses', {
    sectionHeaderText: 'Expenses',
    receivedColumnName: 'Received',
    receivedTooltip: 'Received',
    accountColumnName: 'Account',
    amountColumnName: 'Amount',
    memoColumnName: 'Memo',
});
